// extracted by mini-css-extract-plugin
export default {"popover-text-border":"person-popover-module__popover-text-border__2DexP"};